import { createSlice } from '@reduxjs/toolkit';
import { CustomWorkTimeMessageType } from '../../types/custom-work-time';
const initialState = {
    stores: [],
    storesError: null,
    isStoresPending: false,
    storesFilter: {},
    selectedStore: null,
    customWorkTimes: [],
    customWorkTimesError: null,
    isCustomWorkTimesPending: false,
};
export const storesSlice = createSlice({
    name: 'stores',
    initialState,
    selectors: {
        getSelectedStore(state) {
            return state.selectedStore;
        },
        lastResellerStoreCustomWorkTime(state) {
            return [...state.customWorkTimes]
                .reverse()
                .find(customWorkTime => customWorkTime.messageType === CustomWorkTimeMessageType.Reseller);
        },
    },
    reducers: {
        selectStore: (state, action) => {
            state.selectedStore = action.payload;
        },
        resetSelectedStore: state => {
            state.selectedStore = null;
        },
        filterStores: (state, action) => {
            state.storesFilter = action.payload;
        },
    },
});
export const { getSelectedStore, lastResellerStoreCustomWorkTime } = storesSlice.selectors;
export const { selectStore, resetSelectedStore, filterStores } = storesSlice.actions;
